var PROMO_ENGINE_S3='https://s3.amazonaws.com/assets.runyourpool.com/images/PromoEngine';export{PROMO_ENGINE_S3};